var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHidden)?_c('div',{class:_vm.classObject},_vm._l((_vm.row),function(achievement,i){return _c('normal-achievement',{key:i,staticClass:"l-achievement-grid__cell",attrs:{"achievement":achievement,"is-obscured":_vm.isObscured}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }